import apiClient from "../../../api/apiClient";
const BASE_PATH = "/admin/samvat";

export const createSamvat = async (createSamavatValues) => {
  const response = await apiClient.post(BASE_PATH + "/", createSamavatValues);
  return response.data;
};

export const getSamvat = async () => {
  const response = await apiClient.post(`${BASE_PATH}/get`, {});
  return response.data;
};

export const updateSamvat = async (updateSamvatValues) => {
  const response = await apiClient.put(`${BASE_PATH}/`, updateSamvatValues);
  return response.data;
};
